module.exports = function() {
	return new Worker(__webpack_public_path__ + "69d70d3963cce69be885.supplies.wrkr.js");
};